import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMastheadTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M43.4 22v-1H1v1h15v7H1v1h15v7H1v1h15v7.4h1V38h12v7.4h1V38h13.4v-1H30v-7h13.4v-1H30v-7h13.4zM29 37H17v-7h12v7zm0-8H17v-7h12v7z"
      style={{
        fill: "#b3b3b5",
      }}
    />
    <path
      d="M43 14v31H2V14h41m0-1H2c-.6 0-1 .4-1 1v31c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V14c0-.6-.5-1-1-1z"
      style={{
        fill: "#6e6f72",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesMastheadTable);
export default Memo;
